<template>
<div>
    <div class="boxes">
        <div class="columns is-multiline" style="margin-bottom:0;">
            <div class="column is-6">
                <div class="title-and-icon-info" style="margin-top: 0px !important; margin-bottom: 0px !important;">
                    <div class="icon-info"><font-awesome-icon icon="database"/></div>
                    <div class="title-info">PostgreSQL Backups</div>
                </div>
            </div>
            <div class="column is-6 has-text-right">
                <div class="columns">
                    <div class="column is-9">
                        <div class="field">
                            <p class="control has-icons-left has-icons-right" :class="{ 'is-loading': loadingDatabases && search.length > 0 }">
                                <input v-model="search" type="text" class="input border-width-2" placeholder="Search database" autocomplete="off" :disabled="showNoDatabasesMessage" />
                                <span class="icon is-small is-left">
                                    <font-awesome-icon icon="search"/>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div @click="addDatabase" class="button is-info is-fullwidth">
                            <font-awesome-icon icon="plus-circle"/><span class="add-account-button-text">Add database</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-if="serviceDisabled" class="column is-full">
                <div class="notification is-danger" style="font-size: 13px; margin-bottom: 10px; margin-top: -5px;">Weap.io is not taking care of your snapshots anymore. Subscribe to <router-link :to="{ name: 'subscriptionSettings' }">a plan</router-link> if you want to have worry-free backups of your cloud servers.</div>
            </div>
            <div v-if="serviceAboutToBeDisabled" class="column is-full">
                <div class="notification is-danger" style="font-size: 13px; margin-bottom: 10px; margin-top: -5px;">Your Weap.io subscription was cancelled. Starting from <strong>{{ user.subscription_cancellation_effective_from }}</strong> it will be effective and Weap.io will stop taking care of your backups. If you want to continue using Weap.io, subscribe to <router-link :to="{ name: 'subscriptionSettings' }">a plan</router-link>.</div>
            </div>
            <div v-if="serviceInTrial" class="column is-full">
                <div class="notification is-info" style="font-size: 13px; margin-bottom: 10px; margin-top: -5px;">Weap.io will take care of your snapshots until <strong>{{ user.trial_expires_at }} UTC</strong>. Subscribe to <router-link :to="{ name: 'subscriptionSettings' }">a plan</router-link> if you want to continue using Weap.io after the free trial.</div>
            </div>
            <div v-if="servicePastDue" class="column is-full">
                <div class="notification is-danger" style="font-size: 13px; margin-bottom: 10px; margin-top: -5px;">We could not process your payment. If we still can't process it until <strong>2019-12-24</strong>, your susbcription will be cancelled automatically and Weap.io will stop taking care of your backups. Make sure to have enough funds on your account. Alternatively you can update your payment details <router-link :to="{ name: 'subscriptionSettings' }">here</router-link>.</div>
            </div> -->
            <div v-if="!loadingDatabases && search.length > 0 && databases.count == 0" class="column is-full">
                <div class="notification is-info" style="font-size: 13px; margin-bottom: 10px; margin-top: -5px;">There are no databases matching the search term <strong>{{ search }}</strong>.</div>
            </div>
            <div v-if="!loadingDatabases" class="column is-full">
                <div class="columns is-multiline">
                    <div v-for="database in databases.data" class="column is-4" v-bind:key="database.id">
                        <database-widget :database="database" :databases-count="4"></database-widget>
                    </div>
                </div>
                <div v-if="hasDatabases" class="columns is-multiline">
                    <div class="column is-full p-bottom-0">
                        <p class="pagination-details">Showing page <span>{{ databases.meta.current_page }}</span> of <span>{{ databases.meta.last_page }}</span></p>
                    </div>
                    <div class="column is-1 is-offset-5 p-top-0 has-text-right">
                        <div @click="paginatePrevPage" :class="{ 'cursor-not-allowed': !prevPageAvailable}" class="button is-default-custom">
                            <font-awesome-icon icon="angle-left"/>
                        </div>
                    </div>
                    <div class="column is-1 p-top-0">
                        <div @click="paginateNextPage" :class="{ 'cursor-not-allowed': !nextPageAvailable}" class="button is-default-custom">
                            <font-awesome-icon icon="angle-right"/>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loadingDatabases" class="column is-full has-text-centered" style="margin-top: 70px !important;">
                <img src="/loader-dark.svg">
            </div>
        </div>
        <no-server-connected v-if="showNoDatabasesMessage" database-type="postgresql"></no-server-connected>
    </div>
    <add-database-v2 v-if="addDatabaseModalOpened" database-type="postgresql"></add-database-v2>
</div>
</template>

<script>
import _ from 'lodash';
import Api from '@/api';
import DatabaseWidget from '@/components/Databases/Widget.vue';
import AddDatabaseV2 from '@/components/Databases/AddV2.vue';
import NoServerConnected from '@/components/Dashboard/NoServerConnected.vue';

export default {
    metaInfo: {
        title: 'PostgreSQL backups - Weap.io',
    },

    components: {
        DatabaseWidget,
        AddDatabaseV2,
        NoServerConnected,
    },

    data() {
        return {
            databases: [],
            loadingDatabases: false,
            page: 1,
            search: '',
            databasesCountFetched: false,
            databasesCount: 0,
            addDatabaseModalOpened: false,
        }
    },

    mounted() {
        this.getDatabases();
        this.listenEvents();
        this.getDatabasesCount();
    },

    methods: {
        getDatabases(successCallback) {
            this.loadingDatabases = true;

            let endpoint = 'users/current/databases/postgresql/paginated?page=' + this.page;
            if (this.search) {
                endpoint += '&search=' + this.search;
            }

            var params = {};

            Api().get(endpoint, { params })
                .then((response) => {
                    this.databases = response.data;

                    if (typeof successCallback === 'function') {
                        successCallback();
                    }
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loadingDatabases = false;
                });
        },

        paginatePrevPage() {
            if (!this.prevPageAvailable) {
                return;
            }

            this.page--;
            this.getDatabases();
        },

        paginateNextPage() {
            if (!this.nextPageAvailable) {
                return;
            }

            this.page++;
            this.getDatabases();
        },

        listenEvents() {
            Event.$on('refreshDatabases', (databaseType, callback) => {
                this.getDatabases(callback);
            });

            Event.$on('addDatabaseClosed', () => {
                this.addDatabaseModalOpened = false;
            });
        },
        
        getDatabasesCount() {
            Api().get('users/current/databases/postgresql/count')
                .then(response => {
                    this.databasesCount = response.data.databases_count;
                    this.databasesCountFetched = true;
                })
        },

        addDatabase() {
            this.addDatabaseModalOpened = true;

            Vue.nextTick(() => {
                Event.$emit('showAddDatabase');
            });
        },
    },

    computed: {
        userId() {
            return localStorage.userId;
        },

        hasDatabases() {
            if (typeof this.databases.count === 'undefined') {
                return false;
            }

            return this.databases.count > 0;
        },

        prevPageAvailable() {
            return this.databases.meta.current_page > 1 && !this.loading;
        },

        nextPageAvailable() {
            return this.databases.meta.current_page < this.databases.meta.last_page && !this.loading;
        },

        serviceDisabled() {
            if (!this.user || typeof this.user.service_disabled === 'undefined') {
                return false;
            }

            return this.user.service_disabled;
        },

        serviceAboutToBeDisabled() {
            if (!this.user || typeof this.user.subscription_cancelled === 'undefined' || typeof this.user.subscription_cancellation_is_effective === 'undefined') {
                return false;
            }

            return this.user.subscription_cancelled && !this.user.subscription_cancellation_is_effective;
        },

        serviceInTrial() {
            if (!this.user || typeof this.user.in_trial === 'undefined') {
                return false;
            }

            return this.user.in_trial && !this.user.subscription_active && !this.user.subscription_cancelled;
        },

        servicePastDue() {
            if (!this.user || typeof this.user.subscription_past_due === 'undefined') {
                return false;
            }

            return this.user.subscription_past_due;
        },

        showNoDatabasesMessage() {
            return this.databasesCount == 0 
                && this.databasesCountFetched 
                && !this.loadingDatabases
            ;
        },
    },

    watch: {
        search: _.debounce(function(search){
            this.page = 1;
            this.getDatabases();
        }, 500)
    }
}
</script>
